function e(r) {
  return r.replace(/#|\(|\)|,|\s|\./g, "_");
}
export {
  e as color2Class
};
